import Pageable from "@/entities/pageable/pageable_collection";
import Vue from "vue";
import { BACKEND_BASE_URL, BACKEND_BASE_URL_READS } from "../backend.types";
import { TransactionDeletionService } from "./transactionDeletion.types";
import { RawPage } from "@/entities/pageable/pageable_types";
import { RawTransactionDeletion, TransactionDeletion } from "@/entities/transaction-deletion";
import { AxiosRequestConfig } from "axios";

export class TransactionDeletionServiceImpl implements TransactionDeletionService {
  async fetchTransactionDeletions(map: Record<string, unknown>): Promise<Pageable<TransactionDeletion>> {
    const { data } = await Vue.$axios.post<RawPage<RawTransactionDeletion>>(
      `${BACKEND_BASE_URL_READS}/api/v1/transaction-deletions`,
      map
    );
    return {
      totalResult: data.totalResult,
      results: (data.results ?? []).map((raw) => new TransactionDeletion(raw)),
    };
  }

  async downloadDetailsById(transactionDeletionId: string): Promise<File> {
    const url = `${BACKEND_BASE_URL_READS}/api/v1/transaction-deletions/${transactionDeletionId}/details/download`;
    const responseType: AxiosRequestConfig = { responseType: "blob" };
    const response = await Vue.$axios.get(url, responseType);
    const contentType = response.headers["content-type"];
    const filename = `transaction-deletion-${transactionDeletionId}.xlsx`;
    const blob = new Blob([response.data as BlobPart], { type: contentType });
    return new File([blob], filename);
  }

  async downloadTemplate(): Promise<File> {
    const url = `${BACKEND_BASE_URL_READS}/api/v1/transaction-deletions/download-template`;
    const responseType: AxiosRequestConfig = { responseType: "blob" };
    const response = await Vue.$axios.post(url, {}, responseType);
    const contentType = response.headers["content-type"];
    const filename = `transaction-deletion-template.xlsx`;
    const blob = new Blob([response.data as BlobPart], { type: contentType });
    return new File([blob], filename);
  }

  async isUserAllowed(): Promise<{ allowed: boolean }> {
    const { data } = await Vue.$axios.get<{ allowed: boolean }>(
      `${BACKEND_BASE_URL_READS}/api/v1/me/allowed-user-deletion`
    );
    return data;
  }

  async uploadDeletionFile(formData: FormData): Promise<void> {
    await Vue.$axios.post(`${BACKEND_BASE_URL}/api/v1/transaction-deletions/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }
}
